import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';

import { HeaderComponent } from './components/header/header.component';
import { ArticleWithPublisher } from './components/articleAndPub/articleAndPub.component';
import { FooterComponent } from './components/footer/footer.component';
import { AppComponent } from './components/app/app.component';
import { IndexComponent } from './components/index/index.component';
import { ListReviewsPage } from './components/listFilmReviewsPage/listFilmReviewsPage.component';
import { WhatsNewHeaderComponent } from './components/indexWhatsNewHeader/indexWhatsNewHeader.component';
import { IndexDividedContentComponent } from './components/indexDividedContent/indexDividedContent.component';
import { IndexSingleRowContentComponent } from './components/indexSingleRowContent/indexSingleRowContent.component';
import { PageBottomSpaceComponent } from './components/pageBottomSpace/pageBottomSpace.component';
import { WrittenFilmReviewPage } from './components/writtenFilmReviewPage/writtenFilmReviewPage.component';
import { FilmSideMenuComponent } from './components/filmSideMenu/filmSideMenu.component';
import { FilmHeroImageComponent } from './components/filmHeroImage/filmHeroImage.component';
import { FilmSynopsisAndGenresComponent } from './components/filmSynopsisWithGenre/filmSynopsisWithGenre.component';
import { ArticleDividingLineComponent } from './components/articleDividingLine/articleDividingLine.component';
import { ArticleContentComponent } from './components/articleContent/articleContent.component';
import { SeeAlsoComponent } from './components/seeAlso/seeAlso.component';
import { ReferencesComponent } from './components/references/references.component';
import { VideoFilmReviewPage } from './components/videoFilmReviewPage/videoFilmReviewPage.component';
import { PageSectionHeaderComponent } from './components/pageSectionHeader/pageSectionHeader.component';
import { EmbededVideoComponent } from './components/videoEmbeded/videoEmbeded.component';
import { PageSectionFirstHeaderComponent } from './components/pageSectionFirstHeader/pageSectionFirstHeader.component';
import { CriticalEssayPage } from './components/criticalEssayPage/criticalEssayPage.component';
import { ArticlePubAuthComponenet } from './components/articlePubAuth/articlePubAuth.component';
import { VideoPage } from './components/videoPage/videoPage.component';
import { ArticleSideMenuComponent } from './components/articleSideMenu/articleSideMenu.component';
import { ArticleHeroImageComponent } from './components/articleHeaderImage/articleHeaderImage.component';
import { AuthorSectionComponent } from './components/authorSection/authorSection.component';
import { ReferencedFilmsComponenet } from './components/referencedFilms/referencedFilms.component';
import { ImageSectionComponent } from './components/imageSection/imageSection.component';
import { TheoreticalEssayPage } from './components/theoreticalEssayPage/theoreticalEssayPage.component';
import { NewsPage } from './components/newsPage/newsPage.component';
import { ListSideMenuComponent } from './components/listSideMenu/listSideMenu.component';
import { ListPageContentBoxesComponent } from './components/listPageContentBoxes/listPageContentBoxes.component';
import { ListPageAllContentBoxComponent } from './components/listAllContentBox/listAllContentBox.component';
import { listContentComponent } from './components/listContent/listContent.component';
import { PagnationComponent } from './components/pagnation/pagnation.component';
import { ListScholarlyArticlesPage } from './components/listScholarlyArticlesPage/listScholarlyArticlesPage.component';
import { ListNewsPage } from './components/listNewsPage/listNewsPage.component';
import { ListVideosPage } from './components/listVideosPage/listVideosPage.component';
import { AboutPage } from './components/aboutPage/aboutPage.component';
import { LeadFilmCriticComponent } from './components/leadFilmCriticComponent/leadFilmCriticComponent.component';
import { AboutPageContributorComponent } from './components/aboutPageContributor/aboutPageContributor.component';
import { BlankSpaceComponent } from './components/blankSpace/blankSpace.component';
import { SystemAdminComponent } from './components/systemAdministrator/systemAdministrator.component';
import { ContentFormComponent } from './components/contactForm/contactForm.component';
import { FilmService } from "./services/film.service";
import { PersonService } from "./services/person.service";
import { ContentService } from "./services/content.service";
import { v1ComponentInfo } from "./components/v1ComponentInfo/v1ComponentInfo.component";
import { ArticlePageContentAndSub } from "./components/articlePageContentAndSub/articlePageContentAndSub.component";
import { AppRoutingModule } from "./app-routing.module";
import { MobileSideMenu } from "./components/mobileSideMenu/mobileSideMenu.component";
import { MobileHeroFilm } from "./components/mobileHeroFilm/mobileHeroFilm.component";
import { IndexWhatsNewHeaderMobile } from "./components/indexMobileWhatsNewHeader/indexMobileWhatsNewHeader.component";
import { IndexMobileContentLeft } from "./components/indexMobileContentLeft/indexMobileContentLeft.component";
import { IndexMobileContentRight } from "./components/indexMobileContentRight/indexMobileContentRight.component";
import { MobileHeroArticle } from "./components/mobileHeroArticle/mobileHeroArticle.component";
import { LoginPage } from "./components/loginPage/loginPage.component";
import { AdminConsolePage } from "./components/adminConsolePage/adminConsolePage.component";
import { AuthUserSideMenu } from "./components/authUserSideMenu/authUserSideMenu.component";
import { AuthConsoleThreeButtonComponent } from "./components/authConsoleThreeButtonComponent/authConsoleThreeButtonComponent.component";
import { AddContentPage } from "./components/adminAddContentPage/adminAddContentPage.component";
import { SearchField } from "./components/searchField/searchField.component";
import { ListContentFilmReview } from "./components/listContentFilmReview/listContentFilmReview.component";
import { ContributorService } from 'app/services/contributor.service';

@NgModule({
  declarations: [
    HeaderComponent,
    ArticleWithPublisher,
    FooterComponent,
    AppComponent,
    IndexComponent,
    ListReviewsPage,
    WhatsNewHeaderComponent,
    IndexDividedContentComponent,
    IndexSingleRowContentComponent,
    PageBottomSpaceComponent,
    WrittenFilmReviewPage,
    FilmSideMenuComponent,
    FilmHeroImageComponent,
    FilmSynopsisAndGenresComponent,
    ArticleDividingLineComponent,
    ArticleContentComponent,
    SeeAlsoComponent,
    ReferencesComponent,
    VideoFilmReviewPage,
    PageSectionHeaderComponent,
    EmbededVideoComponent,
    PageSectionFirstHeaderComponent,
    CriticalEssayPage,
    ArticlePubAuthComponenet,
    VideoPage,
    ArticleSideMenuComponent,
    ArticleHeroImageComponent,
    AuthorSectionComponent,
    ReferencedFilmsComponenet,
    ImageSectionComponent,
    TheoreticalEssayPage,
    NewsPage,
    ListSideMenuComponent,
    ListPageContentBoxesComponent,
    ListPageAllContentBoxComponent,
    listContentComponent,
    PagnationComponent,
    ListScholarlyArticlesPage,
    ListNewsPage,
    ListVideosPage,
    AboutPage,
    LeadFilmCriticComponent,
    AboutPageContributorComponent,
    BlankSpaceComponent,
    SystemAdminComponent,
    ContentFormComponent,
    v1ComponentInfo,
    ArticlePageContentAndSub,
    MobileSideMenu,
    MobileHeroFilm,
    IndexWhatsNewHeaderMobile,
    IndexMobileContentLeft,
    IndexMobileContentRight,
    LoginPage,
    MobileHeroArticle,
    AdminConsolePage,
    AuthUserSideMenu,
    AuthConsoleThreeButtonComponent,
    AddContentPage,
    ListContentFilmReview,
    SearchField

  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule
  ],
  providers: [
    FilmService,
    PersonService,
    ContentService, 
    ContributorService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/app.module.ts